export const SCENE_CONFIG_MAP = {
    "auto": {
      "purpose": "news",
      "timeSec": 60,
      "language": null,
      "slidesNum": 5,
      "useBackground": false,
      "useAutoSlidesNum": false,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "clip",
      "mediaResourceType": "search",
      "images": [],
      "orientation": "web"
    },
    "news": {
      "purpose": "news",
      "language": null,
      "slidesNum": 5,
      "useBackground": false,
      "useAutoSlidesNum": false,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "clip",
      "mediaResourceType": "search",
      "images": [],
      "orientation": "web"
    },
    "youtube": {
      "purpose": "youtube",
      "timeSec": 60,
      "language": null,
      "slidesNum": 5,
      "useBackground": false,
      "useAutoSlidesNum": false,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "background",
      "mediaResourceType": "generative",
      "generativeMediaStyle": "realistic",
      "orientation": "mobile"
    },
    "business": {
      "purpose": "business",
      "language": null,
      "slidesNum": 5,
      "useBackground": true,
      "useAutoSlidesNum": true,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "clip",
      "mediaResourceType": "premium",
      "orientation": "web"
    },
    "business2": {
      "purpose": "business",
      "language": null,
      "slidesNum": 5,
      "useBackground": true,
      "useAutoSlidesNum": true,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "clip",
      "mediaResourceType": "premium",
      "orientation": "web"
    },
    "ko_business": {
      "purpose": "ko_business",
      "language": null,
      "slidesNum": 5,
      "useBackground": true,
      "useAutoSlidesNum": true,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "clip",
      "mediaResourceType": "premium",
      "orientation": "web"
    },
    "ko_business2": {
      "purpose": "ko_business2",
      "language": null,
      "slidesNum": 5,
      "useBackground": true,
      "useAutoSlidesNum": true,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "clip",
      "mediaResourceType": "premium",
      "orientation": "web"
    },
    "commerce": {
      "purpose": "commerce",
      "language": null,
      "slidesNum": 5,
      "useBackground": false,
      "useAutoSlidesNum": true,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "clip",
      "mediaResourceType": "extract",
      "orientation": "web"
    },
    "education": {
      "purpose": "education",
      "language": null,
      "slidesNum": 5,
      "useBackground": false,
      "useAutoSlidesNum": true,
      "useImagePostProcess": false,
      "whereMediaPutOnScene": "clip",
      "mediaResourceType": "premium",
      "orientation": "web"
    }  
  }